import React, { useRef } from 'react'
import './Join.css';
import emailjs from '@emailjs/browser'
export default function Join() {
    const form=useRef();
    const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_zc4yh1z', 'template_9jkn4ts', form.current, {
        publicKey: 'lKV_xiKlXxXAAyZTk',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };

  return (
    <div className="Join">
        <div className="left-j">
            <hr/>
            <div>
                <span className='stroke-text'>READY TO</span>
                <span> LEVEL UP</span>
            </div>
            <div>
                <span>YOUR BODY</span>
                <span className='stroke-text'> WITH US?</span>
            </div>
        </div>
        <div className="right-j">
            <form ref={form} action="" name='name' className='email-container' onSubmit={sendEmail}>
                <input  type="email" name='user'   className='Email' placeholder='Enter Your Email'/>
                <button className='btn btn-j'>Join Now</button>
            </form>
        </div>
    </div>
  )
}
